import { Button, StatusScreen } from '@servicetim/ui/components';
import { useSession } from '@servicetim/ui/lib';
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * OIDC redirect target (`config.cognito.redirectUri`). The AuthProvider exchanges `?code=` for
 * tokens on mount; this page just waits for the outcome and sends the user back where they were.
 */
export function CallbackPage() {
  const router = useRouter();
  const { authEnabled, status, returnTo, error, signIn } = useSession();

  useEffect(() => {
    if (!authEnabled || status === 'authenticated') {
      // history.replace accepts any same-origin path; `returnTo` was validated by the session.
      router.history.replace(returnTo ?? '/');
    } else if (status === 'unauthenticated') {
      // Landed here without a pending sign-in: the app layout will start a new one.
      router.history.replace('/');
    }
  }, [authEnabled, status, returnTo, router]);

  if (status === 'error') {
    return (
      <StatusScreen
        tone="error"
        title="Sign-in could not be completed"
        description={error?.message ?? 'The identity provider returned an error.'}
        action={<Button onClick={() => void signIn('/')}>Try again</Button>}
      />
    );
  }

  return <StatusScreen tone="loading" title="Completing sign-in..." />;
}
